<template>
  <div>
    <!--审核 -->
    <el-dialog :title="$t('message.examine')" :visible.sync="dialogVisible" width="600px" center
      :close-on-click-modal="false">
      <div class="content">
        <el-form :model="ruleForm" ref="ruleForm" label-width="130px" class="demo-ruleForm">
          <el-form-item label="审核备注:" prop="y_edit_remark">
            <el-input v-model="ruleForm.y_confirm_remark" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="yConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    id: { type: Number }
  },
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
      },


    };
  },
  methods: {
    yConfirm() {
      this.$api.financialApi.cashyConfirm(this.ruleForm).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.cashList()
      })
    },

  },
  watch: {
    dialogVisible() {
      this.ruleForm = {
        id: this.id,
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.content {
  padding: 0 50px;

  /deep/.el-form-item {


    .el-form-item__content {
      display: flex;
    }

    .imgUp {
      display: flex;
      align-items: flex-start;

      /deep/.avatar-uploader .el-upload {
        width: 80px;
        height: 80px;
        margin-right: 10px;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background-color: white;
      }

      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }

      .el-upload--text {
        border: 1px solid #ccc;
      }

      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
      }

      /deep/.el-image {
        width: 80px !important;
        height: 80px !important;
      }

      /deep/.imgBox {
        height: 80px;
      }
    }
  }

  // /deep/.el-form-item__label {
  //   margin: 0;
  //   padding: 0;
  // }

  .row {
    display: flex;
    width: 100%;

    .item {
      flex: 1;
      display: flex;
    }
  }
}
</style>